import currencyFormatting from '@package/utils/src/currencyFormatting';
import config from 'config-base';
import { GiftCardsListProps } from './types';
import { GiftCard } from '@package/core/src/giftCard/types';
import RemoveCouponButton from '../RemoveCouponButton';
import styles from './GiftCardList.module.css';
import clsx from 'clsx';

const GiftCardList = ({ id, title, data, onDelete }: GiftCardsListProps) =>
  data && data?.length > 0 ? (
    <div data-testid={id} id={id} className={styles.growIn}>
      <div className={clsx(styles.giftCardList, { [styles.giftCardListAGD]: config.brandCode === '2' })}>
        <div className={clsx(styles.giftCardBox, { [styles.giftCardBoxAGD]: config.brandCode === '2' })}>{title}</div>
        <div className={styles.giftCardDataBox}>
          {data?.map((giftCard: GiftCard) => (
            <div key={giftCard.serialNumber} className={styles.giftCardListContainer}>
              <span className={styles.giftCardSerialNumber}>
                {giftCard.loyaltyCard
                  ? `${currencyFormatting(giftCard.currentBalance)} (${Math.round(
                      giftCard.currentBalance * 100,
                    )} points)`
                  : giftCard.serialNumber}
              </span>
              {!giftCard.loyaltyCard && (
                <span className={styles.giftCardCurrentBalance}>{currencyFormatting(giftCard.currentBalance)}</span>
              )}
              <RemoveCouponButton
                onClick={async () => await onDelete(giftCard.serialNumber)}
                id="remove-gift-card-btn"
                data-testid='remove-gift-card-btn'
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  ) : null;

export default GiftCardList;
